import React, { useState } from "react";
import { useDispatch } from "react-redux";

import styles from "./MobileComponents.module.css";
import ChooseInfoBlock from "../rightData/ChooseInfoBlock";
import { setItemId } from "../../../../store/slices/currentItem.slice";
import ButtonIcon from "../../../../components/icons/ButtonIcon";
import { useTranslation } from "react-i18next";
import { useGetVideoDetailsQuery } from "../../../../store/api/filmAPI";
import useLikeClick from "../../../../hooks/useLikeClick";
import useFavouriteClick from "../../../../hooks/useFavouriteClick";
import { setShareModal } from "../../../../store/slices/modals.slice";
import { languageHandler } from "../../../../utils/helpers";
import useShareClick from "../../../../hooks/useShareClick";

interface IProps {
  voteCount: number;
  isMobile: boolean;
  currentItemId: number;
  clickHandler: () => void;
  item: any;
}
const MobileBottomInfoBlock = ({ voteCount, isMobile, currentItemId, clickHandler, item }: IProps) => {
  const dispatch = useDispatch();
  const [hoveredButton, setHoveredButton] = useState(false);

  const { i18n } = useTranslation();
  const { likesList, likeHandler } = useLikeClick();
  const { favoritesList, favouritesHandler } = useFavouriteClick();
  const { shareList } = useShareClick();

  const { data, isLoading } = useGetVideoDetailsQuery({
    queries: { language: languageHandler(i18n.language) },
    id: currentItemId,
  });

  const shareHandler = () => {
    dispatch(setShareModal(true));
  };

  if (isLoading) {
    return <></>;
  }

  return (
    <div className={styles.mobileBottomMenu}>
      <ChooseInfoBlock
        item={item}
        isMobile={isMobile}
        reviewHandler={clickHandler}
        likeHandler={likeHandler}
        shareHandler={shareHandler}
        favouritesHandler={favouritesHandler}
        shared={shareList.data?.results.includes(data?.id)}
        liked={likesList.data?.results.includes(data?.id)}
        inFavourites={favoritesList.data?.results.includes(data?.id)}
      />
      <button
        onMouseEnter={() => setHoveredButton(true)}
        onMouseLeave={() => setHoveredButton(false)}
        onClick={() => {
          clickHandler();
          dispatch(setItemId(currentItemId));
        }}
        className={`${styles.footerContentButton} ${isMobile ? styles.footerContentButtonMobile : ""}`}
      >
        <ButtonIcon stroke={hoveredButton} />
      </button>
    </div>
  );
};

export default MobileBottomInfoBlock;
